import { AttributeTypes } from "@iddataweb/idw-common-ui/enums";
import { AttributeInput } from "@idw-types/data";
import { AttributeFormState } from "@idw-types/state/attribute-form-state";
import { FrontAndBackAttributeImages } from "@containers/front-and-back-attribute-images/front-and-back-attribute-images";
import { HiddenAttributeImage } from "@containers/hidden-attribute-image/hidden-attribute-image";
import { SingleAttributeImage } from "@containers/single-attribute-image/single-attribute-image";
import { PlaceholderInput } from "@containers/inputs/placeholder-input/placeholder-input";
import { CompanyNameInput } from "@containers/inputs/company-name-input/company-name-input";
import { DateOfBirthInput } from "@containers/inputs/date-of-birth-input/date-of-birth-input";
import { EmailInput } from "@containers/inputs/email-input/email-input";
import { EmailOrPhonePINPreferenceInput } from "@containers/inputs/email-or-phone-pin-preference-input/email-or-phone-pin-preference-input";
import { FullNameInputContainer } from "@containers/inputs/full-name-input/full-name-input-container";
import { GenderSelectInput } from "@containers/inputs/gender-select-input/gender-select-input";
import { NationalIDNumberInput } from "@containers/inputs/national-id-number-input/national-id-number-input";
import { PINDeliveryPreferenceInput } from "@containers/inputs/pin-delivery-preference-input/pin-delivery-preference-input";
import { SSN4InputContainer } from "@containers/inputs/ssn4-input/ssn4-input-container";
import { SSN9InputContainer } from "@containers/inputs/ssn9-input/ssn9-input-container";
import { UnknownInput } from "@containers/inputs/unknown-input/unknown-input";
import { InternationalTelephoneInput } from "@containers/inputs/international-telephone-input/international-telephone-input";
import { CountrySelectInput } from "@containers/inputs/country-select-input/country-select-input";
import { PassportNumberInput } from "@containers/inputs/passport-number-input/passport-number-input";
import { PanNumberInput } from "@containers/inputs/pan-number-input/pan-number-input";
import { PhysicianLicenseNumberInput } from "@containers/inputs/physician-license-number-input/physician-license-number-input";
import { PolicyNumberInput } from "@containers/inputs/policy-number-input/policy-number-input";
import { DriversLicenseNumberInput } from "@containers/inputs/drivers-license-number-input/drivers-license-number-input";
import { IDCardNumberInput } from "@containers/inputs/id-card-number-input/id-card-number-input";
import { DriversLicenseStateSelectInput } from "@containers/inputs/drivers-license-state-select-input/drivers-license-state-select-input";
import { AadharCardNumberInput } from "@containers/inputs/aadhar-card-number-input/aadhar-card-number-input";
import { IDSelectionAttribute } from "@containers/inputs/id-select-input/id-selection-attribute";
import { AlphaNumericInput } from "@containers/inputs/alphanumeric-input/alphanumeric-input";
import { NumericInput } from "@containers/inputs/numeric-input/numeric-input";
import { InternationalAddressInputContainer } from "@containers/inputs/international-address-input/international-address-input-container";
import { BioGovOrKbaSelectionAttribute } from "@containers/inputs/bio-gov-or-kba-select-input/bio-gov-or-kba-selection-attribute";
import { NationalityInput } from "../containers/inputs/nationalilty-input/nationalilty-input";

export const getComponentByAttribute = (attribute: AttributeFormState) => {
	let attributeComponent = getComponentByAttributeType(attribute.type);

	if (!attributeComponent) {
		attributeComponent = getComponentByAttributeTemplateName(attribute.templateName);
	}

	if (!attributeComponent) {
		attributeComponent = UnknownInput;
	}

	return attributeComponent;
};


const getComponentByAttributeTemplateName = (attributeTemplateName: string) => {
	const lowerCaseValue = attributeTemplateName.toLowerCase();
	switch (lowerCaseValue) {
		case 'numeric':
			return NumericInput;
		case 'alphanumeric':
			return AlphaNumericInput;
		default:
			return null;
	}
}

const getComponentByAttributeType = (attributeType: AttributeTypes) => {
	switch (attributeType) {
		case AttributeTypes.FULL_NAME:
			return FullNameInputContainer;
		case AttributeTypes.COMPANY_NAME:
			return CompanyNameInput;
		case AttributeTypes.INTERNATIONAL_TELEPHONE:
			return InternationalTelephoneInput;
		case AttributeTypes.PIN_DELIVERY_PREFERENCE:
			return PINDeliveryPreferenceInput;
		case AttributeTypes.EMAIL_OR_PHONE_PIN_PREFERENCE:
			return EmailOrPhonePINPreferenceInput;
		case AttributeTypes.EMAIL:
			return EmailInput;
		case AttributeTypes.INTERNATIONAL_ADDRESS:
			return InternationalAddressInputContainer;
		case AttributeTypes.SSN9:
			return SSN9InputContainer;
		case AttributeTypes.SSN4:
			return SSN4InputContainer;
		case AttributeTypes.DOB:
			return DateOfBirthInput;
		case AttributeTypes.NATIONAL_ID:
			return NationalIDNumberInput;
		case AttributeTypes.DATE:
			return DateOfBirthInput;
		case AttributeTypes.GENDER:
			return GenderSelectInput;
		case AttributeTypes.COUNTRY:
			return CountrySelectInput;
		case AttributeTypes.DRIVERS_LICENSE_NUMBER:
			return DriversLicenseNumberInput;
		case AttributeTypes.DRIVERS_LICENSE_IMAGES:
			return FrontAndBackAttributeImages;
		case AttributeTypes.ID_CARD_NUMBER:
			return IDCardNumberInput;
		case AttributeTypes.CAMERA_SNAPSHOT:
			return SingleAttributeImage;
		case AttributeTypes.PASSPORT_NUMBER:
			return PassportNumberInput;
		case AttributeTypes.PASSPORT_IMAGE:
			return SingleAttributeImage;
		case AttributeTypes.LICENSE_OR_ID_CARD:
		case AttributeTypes.LICENSE_OR_PASSPORT:
		case AttributeTypes.LICENSE_OR_PASSPORT_OR_BROWSE:
		case AttributeTypes.LICENSE_PASSPORT_OR_ID_CARD:
		case AttributeTypes.PASSPORT_OR_ID_CARD:
		case AttributeTypes.INTERNATIONAL_LICENSE_OR_PASSPORT:
		case AttributeTypes.AADHAR_PAN_OR_PASSPORT:
			return IDSelectionAttribute;
		case AttributeTypes.AADHAR_CARD_IMAGES:
			return FrontAndBackAttributeImages;
		case AttributeTypes.AADHAR_CARD_NUMBER:
			return AadharCardNumberInput;
		case AttributeTypes.PAN_NUMBER:
			return PanNumberInput;
		case AttributeTypes.AUDIT_TRAIL_IMAGE:
			return SingleAttributeImage;
		case AttributeTypes.PHYSICIAN_LICENSE_NUMBER:
			return PhysicianLicenseNumberInput;
		case AttributeTypes.DRIVERS_LICENSE_STATE:
			return DriversLicenseStateSelectInput;
		case AttributeTypes.LOW_QUALITY_AUDIT_TRAIL_IMAGE:
		case AttributeTypes.THREE_D_FACE_MAP:
			return HiddenAttributeImage;
		case AttributeTypes.POLICY_NUMBER:
			return PolicyNumberInput;
		case AttributeTypes.ALPHANUMERIC:
		case AttributeTypes.ALPHANUMERIC_OTHER:
			return AlphaNumericInput;
		case AttributeTypes.NUMERIC:
			return NumericInput;
		case AttributeTypes.BIO_GOV_OR_KBA:
			return BioGovOrKbaSelectionAttribute;
		case AttributeTypes.NATIONALITY:
			return NationalityInput;
		default:
			return null;
	}
};

export const getAttributePlaceHolderComponent = (attribute: AttributeFormState) => {
	const parameter = attribute.type.includes('CustomAttribute')
		? attribute.templateName
		: attribute.type;
	switch (parameter) {
		case AttributeTypes.PIN_DELIVERY_PREFERENCE:
			return PINDeliveryPreferenceInput;
		case AttributeTypes.EMAIL_OR_PHONE_PIN_PREFERENCE:
			return EmailOrPhonePINPreferenceInput;
		case AttributeTypes.FULL_NAME:
		case AttributeTypes.COMPANY_NAME:
		case AttributeTypes.INTERNATIONAL_TELEPHONE:
		case AttributeTypes.EMAIL:
		case AttributeTypes.ADDRESS:
		case AttributeTypes.INTERNATIONAL_ADDRESS:
		case AttributeTypes.SSN9:
		case AttributeTypes.SSN4:
		case AttributeTypes.DOB:
		case AttributeTypes.NATIONAL_ID:
		case AttributeTypes.DATE:
		case AttributeTypes.GENDER:
		case AttributeTypes.COUNTRY:
		case AttributeTypes.DRIVERS_LICENSE_NUMBER:
		case AttributeTypes.DRIVERS_LICENSE_IMAGES:
		case AttributeTypes.CAMERA_SNAPSHOT:
		case AttributeTypes.PASSPORT_NUMBER:
		case AttributeTypes.ID_CARD_NUMBER:
		case AttributeTypes.ID_CARD_IMAGES:
		case AttributeTypes.POLICY_NUMBER:
		case AttributeTypes.PASSPORT_IMAGE:
		case AttributeTypes.LICENSE_OR_ID_CARD:
		case AttributeTypes.LICENSE_OR_PASSPORT:
		case AttributeTypes.LICENSE_OR_PASSPORT_OR_BROWSE:
		case AttributeTypes.LICENSE_PASSPORT_OR_ID_CARD:
		case AttributeTypes.PASSPORT_OR_ID_CARD:
		case AttributeTypes.AADHAR_PAN_OR_PASSPORT:
		case AttributeTypes.AADHAR_CARD_IMAGES:
		case AttributeTypes.PAN_IMAGES:
		case AttributeTypes.AUDIT_TRAIL_IMAGE:
		case AttributeTypes.LOW_QUALITY_AUDIT_TRAIL_IMAGE:
		case AttributeTypes.THREE_D_FACE_MAP:
		case AttributeTypes.PHYSICIAN_LICENSE_NUMBER:
		case AttributeTypes.DRIVERS_LICENSE_STATE:
		case AttributeTypes.ALPHANUMERIC:
		case AttributeTypes.ALPHANUMERIC_OTHER:
		case AttributeTypes.NUMERIC:
		case AttributeTypes.INTERNATIONAL_LICENSE_OR_PASSPORT:
		case AttributeTypes.BIO_GOV_OR_KBA:
		case AttributeTypes.NATIONALITY:
			return PlaceholderInput;
		default:
			return null;
	}
};

export const getDefaultFormInputValues = (attribute: AttributeInput) => {
	const defaultCustomFormInputValue: { [key: string]: string } = {};
	const keys = attribute.fields.map(field => field.name);
	keys.forEach(key => {
		defaultCustomFormInputValue[key] = "";
	});
	return defaultCustomFormInputValue;
};

export const isHiddenAttribute = (attributeType: AttributeTypes) => {
	return [AttributeTypes.LOW_QUALITY_AUDIT_TRAIL_IMAGE, AttributeTypes.THREE_D_FACE_MAP].includes(attributeType);
};

export const isFrontAndBackImageAttribute = (attributeType: AttributeTypes) => {
	return [
		AttributeTypes.DRIVERS_LICENSE_IMAGES,
		AttributeTypes.PAN_IMAGES,
		AttributeTypes.AADHAR_CARD_IMAGES,
		AttributeTypes.ID_CARD_IMAGES
	].includes(attributeType);
};

export const isSingleImageAttribute = (attributeType: AttributeTypes) => {
	return [
		AttributeTypes.PASSPORT_IMAGE,
		AttributeTypes.CAMERA_SNAPSHOT,
		AttributeTypes.AUDIT_TRAIL_IMAGE
	].includes(attributeType);
};